import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { EnterpriseFollow } from './EnterpriseFollow';
import { AnimatedLink } from '../../../components/animated-link/AnimatedLink';
import styles from './enterprise_header_top.module.scss';
import { EnterpriseContext } from '../EnterpriseContext';

type Props = {
  allDecisionsLink: string;
};

export const EnterpriseHeaderTop: FC<Props> = ({ allDecisionsLink }) => {
  const {
    enterpriseInfos: {
      raisonSociale,
      isAdministration,
      isAssociation,
      dateRadiation,
      enterpriseId,
      siren,
    },
    experience: { decisionCount },
  } = useContext(EnterpriseContext);
  if (!raisonSociale) return null;

  return (
    <div className={styles.container}>
      <div
        className={`entity__header__picture ${styles.picture}`}
        style={{
          backgroundImage: 'url(/img/icons/entities/enterprise.svg)',
        }}
      />
      <div className={styles.titleContainer}>
        <h1 className={`entity__header__title ${styles.title}`}>
          {raisonSociale}
        </h1>
        <span className={styles.titleInfo}>
          <FormattedMessage
            id="header/EnterpriseHeaderTop.tsx/1"
            values={{ siren }}
          />{' '}
          {isAdministration && (
            <FormattedMessage id="header/EnterpriseHeaderTop.tsx/2" />
          )}
          {isAssociation && (
            <FormattedMessage id="header/EnterpriseHeaderTop.tsx/3" />
          )}
          {!isAdministration && !isAssociation && (
            <FormattedMessage id="header/EnterpriseHeaderTop.tsx/4" />
          )}
          {dateRadiation && (
            <span className={styles.radiation}>
              {' '}
              <FormattedMessage
                id="header/EnterpriseHeaderTop.tsx/5"
                values={{ dateRadiation }}
              />
            </span>
          )}
        </span>
        {decisionCount > 0 && (
          <AnimatedLink
            href={allDecisionsLink}
            source="read_all_enterprise_decisions_from_header"
          >
            <span>
              <FormattedMessage
                id="header/EnterpriseHeaderTop.tsx/6"
                values={{ decisionCount }}
              />
            </span>
          </AnimatedLink>
        )}
        <EnterpriseFollow
          raisonSociale={raisonSociale}
          enterpriseId={enterpriseId}
        />
      </div>
    </div>
  );
};
